import { render, staticRenderFns } from "./ReferralCodeComponent.vue?vue&type=template&id=2a5f90a8&scoped=true&"
import script from "./ReferralCodeComponent.vue?vue&type=script&lang=ts&"
export * from "./ReferralCodeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralCodeComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReferralCodeComponent.vue?vue&type=style&index=1&id=2a5f90a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f90a8",
  null
  
)

export default component.exports